<div class="module module-tradeshow seminar" data-view="tradeshow">
    <div [class]="expand ? 'module module-accordion tradeshow-filter initial-active active' : 'module module-accordion tradeshow-filter initial-active'" data-view="accordion-item">
        <div (click)="updateAccordion()" class="title">
            Specify your results
        </div>
        <div id="filter-accordion-content" class="content" style="max-height: none; transition: max-height 0.25s linear, padding 0.25s linear, border-color 0.25s linear;">
            <div class="scrollable-table">
                <div class="module module-inred-form">
                    <div>
                        <div class="tradeshow-filter-wrapper">
                            <div class="tradeshow-filter-left">
                                <div class="select-date">
                                    <div class="form-field form-field-select">
                                        <select (change)="updateDateFilter()" id="filter-date" class="filter-select">
                                            <option value="">All Dates</option>
                                            <option *ngFor="let item of selectableDates" value="{{ item.key }}">{{ item.value }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="select-country">
                                    <div class="form-field form-field-select">
                                        <select (change)="updateCountryFilter()" id="filter-country" class="filter-select">
                                            <option value="">All Countries</option>
                                            <option *ngFor="let item of selectableCountries.countries" value="{{ item.id }}">{{ item.country }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="tradeshow-filter-right">
                                <div class="form-field-wrapper">
                                    <div id="filter-tags" class="c1 form-field checkbox-container">
                                        <div *ngFor="let item of selectableTags.tags" class="label">
                                            <input (click)="updateTagsFilter(item)" id="search_filter_{{ item.key }}" class="filter-input" value="{{ item.key }}" type="checkbox">
                                            <label for="search_filter_{{ item.key }}">{{ item.value }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="module-active-filters">
        <ul class="list">
            <li class="item" *ngIf="filterDate.value !== ''">
                <a class="active-filters-link" data-target="#filter-date">
                    <span class="active-filters-label">{{ filterDate.value }}</span>
                    <span (click)="removeDateFilter()" class="active-filters-close" style="cursor: pointer; vertical-align: middle;"></span>
                </a>
            </li>
            <li class="item" *ngIf="filterCountry.value !== ''">
                <a class="active-filters-link" data-target="#filter-country">
                    <span class="active-filters-label">{{ filterCountry.value }}</span>
                    <span (click)="removeCountryFilter()" class="active-filters-close" style="cursor: pointer; vertical-align: middle;"></span>
                </a>
            </li>
            <li class="item" *ngFor="let item of filterTags">
                <a class="active-filters-link" data-target="#search_filter_{{ item.key }}">
                    <span class="active-filters-label">{{ item.value }}</span>
                    <span (click)="removeTagsFilter(item)" class="active-filters-close" style="cursor: pointer; vertical-align: middle;"></span>
                </a>
            </li>
        </ul>

        <div class="reset-filters" *ngIf="filterDate.value !== '' || filterCountry.value !== '' || filterTags.length > 0 ">
            <a class="active-filters-link" style="cursor: pointer;">
                <span (click)="resetFilter()" class="active-filters-label">Reset all filters</span>
            </a>
        </div>
    </div>

</div>
